import { useLocation } from 'react-router';
import FooterMobile from '../../components/Footer/mobile/FooterMobile';
import HeaderMobile from '../../components/Header/mobile/HeaderMobile';
import useIsDevice from '../../hooks/useIsDevice';
import useScrollRestoration from '../../hooks/useScrollRestoration';
import QuestionMobile from './mobile/QuestionMobile';

const Question = () => {
  const { isMobile } = useIsDevice();
  const { pathname } = useLocation();
  useScrollRestoration(pathname);
  return (
    <>
      {isMobile ? <HeaderMobile /> : null}
      {isMobile ? <QuestionMobile /> : null}
      {isMobile ? <FooterMobile /> : null}
    </>
  );
};

export default Question;
